import { okModalData } from 'src/components/Modal/OkModal';
import { YesNoModalData } from 'src/components/Modal/YesNoModal';
import { renameModalData } from 'src/components/Modal/RenameModal';
import { EmailConfirmationModalData } from 'src/components/Modal/EmailConfirmationModal';

export const modalTypes = {
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
};

export type IModalState = Readonly<{
  isVisible: boolean;
  startClosing: boolean;
  type: string;
  data: okModalData | YesNoModalData | EmailConfirmationModalData | renameModalData;
}>;
